import type { Filtro } from '../types';

interface Props {
  valor: Filtro;
  aoMudar: (filtro: Filtro) => void;
}

const CHIPS: { valor: Filtro; rotulo: string }[] = [
  { valor: 'todas', rotulo: 'Todas' },
  { valor: 'faltam', rotulo: 'Faltam' },
  { valor: 'alergia', rotulo: 'Com alergia' },
  { valor: 'remedio', rotulo: 'Tomam remédio' },
  { valor: 'alimentacao', rotulo: 'Restrição alimentar' },
];

// Fila de pílulas com rolagem horizontal, acima dos cartões.
export default function ChipsFiltro({ valor, aoMudar }: Props) {
  return (
    <div className="-mx-4 w-[calc(100%+2rem)] max-w-[calc(100%+2rem)] overflow-x-auto overscroll-x-contain px-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      <div className="flex w-max min-w-full gap-2">
        {CHIPS.map((chip) => {
          const ativo = chip.valor === valor;
          return (
            <button
              key={chip.valor}
              type="button"
              onClick={() => aoMudar(chip.valor)}
              aria-pressed={ativo}
              className={`flex h-10 shrink-0 cursor-pointer items-center whitespace-nowrap rounded-full border px-4 text-[14px] font-semibold transition-colors ${
                ativo
                  ? 'border-primary-500 bg-primary-500 text-white'
                  : 'border-background-300 bg-white text-foreground-800 hover:bg-background-100'
              }`}
            >
              {chip.rotulo}
            </button>
          );
        })}
      </div>
    </div>
  );
}